import * as master from '../xhr/master.js';
import * as types from './types/master.js';
import * as adjudicationTypes from './types/adjudication.js';
import * as notificationsTypes from './types/notifications.js';
import * as notifier from './notifier.js';
import * as session from '../services/session.js';
import store, { history } from '../redux/store.js';
import { generatePdf } from '../xhr/generatePdf.js';
import * as loader from './loader.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 *
 */
export function login() {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .login()
            .then((data) => {
                window.location.href = data.url;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 */
export function getMaster() {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .get()
            .then((data) => {
                session.setToken(data.token);

                dispatch({
                    type: types.GET_MASTER_SUCCESS,
                    data
                });

                dispatch({
                    type: notificationsTypes.GET_NOTIFICATIONS_SUCCESS,
                    notifications: data.notifications
                });

                dispatch({
                    type: adjudicationTypes.SET_CLAIM_TYPES,
                    claimTypes: data.claimTypes
                });

                setLoader(dispatch, false);
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * Add a user to the census data, need to know if its a advisor making the request or not
 * @param data
 * @param accountID
 * @returns {function(*): Promise}
 */
export function createBrokerage(data) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .createBrokerage(data)
            .then((response) => {
                dispatch({
                    type: types.CREATE_BROKERAGE_SUCCESS,
                    brokerage: {
                        ...data,
                        brokerageID: response.brokerageID,
                        dateAdded: response.dateAdded
                    }
                });

                setLoader(dispatch, false);
                dispatch(notifier.displayMessage('Brokerage added successfully!'));

                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));

                return false;
            });
    };
}

/**
 *
 * @param {*} body
 * @param {*} uploadType
 */
export function uploadFile(body, uploadType) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .uploadFile(body, uploadType)
            .then((data) => {
                setLoader(dispatch, false);

                if (data && data.failedRecords) {
                    return data.failedRecords;
                }

                dispatch(notifier.displayMessage('File uploaded successfully'));
                return null;
            })
            .catch((error) => {
                console.log(JSON.stringify(error));
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 */
export function logout() {
    return () => {
        session.removeToken();
        history.push('/login');
    };
}

/**
 *
 */
export function getMasterUsers() {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .getMasterUsers()
            .then((data) => {
                dispatch({
                    type: types.GET_MASTER_USERS_SUCCESS,
                    data
                });

                setLoader(dispatch, false);

                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 */
export function addMasterUser(body) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .addMasterUser(body)
            .then((data) => {
                dispatch({
                    type: types.ADD_MASTER_SUCCESS,
                    data: data.body
                });

                setLoader(dispatch, false);
                dispatch(notifier.displayMessage(`${ data.body.firstname } has been added successfully!`));

                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 */
export function setMasterPermission(masterID, access) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .setMasterPermission(masterID, access)
            .then(() => {
                dispatch({
                    type: types.UPDATE_MASTER_ACCESS_SUCCESS,
                    access,
                    masterID
                });

                setLoader(dispatch, false);
                dispatch(notifier.displayMessage(`Permissions changed successfully!`));

                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 */
export function removeMasterUser(masterID) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .removeMasterUser(masterID)
            .then(() => {
                dispatch({
                    type: types.REMOVE_MASTER_SUCCESS,
                    masterID
                });

                setLoader(dispatch, false);
                dispatch(notifier.displayMessage('User removed successfully!'));

                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * @returns {function(*=): (Q.Promise<any> | * | undefined | Promise<void>)}
 */
export function toggleAvailability() {
    return (dispatch) => {
        setLoader(dispatch, true);

        return master
            .toggleAvailability()
            .then(() => {
                dispatch({
                    type: types.UPDATE_MASTER_STATUS,
                    status: store.getState().master.status.toUpperCase() === 'AVAILABLE' ? 'Unavailable' : 'Available'
                });

                setLoader(dispatch, false);
                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * @returns {function(*): Promise<boolean>}
 */
export function getMetrics() {
    return (dispatch) => master
        .getMetrics()
        .then((data) => data)
        .catch((error) => {
            dispatch(notifier.displayError(error));
        });
}

/**
 * @param ComponentName
 * @param fileName
 * @param downloadParams
 * @returns {function(*): Promise<unknown>}
 */
export function getPdf(ComponentName, fileName, downloadParams = {}, formData = false) {    
    return (dispatch) => {
        if (![ 'Invoice', 'RenewalReport' ].includes(ComponentName)) {
            setLoader(dispatch, true);
        }

        return generatePdf(ComponentName, downloadParams, formData)
            .then((data) => {
                if (data.isSentViaEmail === true) {
                    return data;
                }

                const linkSource = `data:application/pdf;base64,${ data }`;
                const downloadLink = document.createElement("a");
                
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();

                setLoader(dispatch, false);
                return data; 
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}